import { type FC } from "react";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { TextButton } from "@root/shared/components/TextButton";
import * as styles from "./styles.css";

type Props = {
  displayImageUrl: string;
  onCopyUrl: () => void;
};

export const SpContent: FC<Props> = ({ displayImageUrl, onCopyUrl }) => (
  <div className={styles.wrapper}>
    <div className={styles.imageCard}>
      <LazyLoadImage src={displayImageUrl} alt="リジョブアワード" width={300} height={238} />
    </div>
    <p className={styles.heading}>Instagramストーリーズへの投稿方法</p>
    <div className={styles.stepWithAction}>
      <span className={styles.stepLabel}>①ページのURLをコピー</span>
      <TextButton size="small" rightIconName="copy" onClick={onCopyUrl}>
        URLコピー
      </TextButton>
    </div>
    <p className={styles.step}>②「シェアする」ボタンを押す</p>
    <p className={styles.step}>③Instagramからストーリーズを選択</p>
    <p className={styles.step}>④リンクステッカーでURLを貼り付ける</p>
  </div>
);
